<div id="fdm-taskbar">
    <ul>
        <li *ngFor="let app of appController.listAll()" style="width:300px!important;height:auto;vertical-align:top;">

            <fdm-workflow-panel [context]="app" [parent]="this"></fdm-workflow-panel>

            <!-- <textarea style="width:100%;height:80px;font-size:8px;">{{ app.config | json }}</textarea> -->

        </li>
    </ul>
</div>